import React from 'react';

import { Nullable } from '@clearverify/types';

import { InboxListItemInfoFragment } from 'src/api';
import { InboxItemTypeWithResources } from 'src/constants/inbox';
import {
  useInboxItemParamId,
  useInboxItemScrollableById,
  useInboxItems,
} from 'src/hooks/inboxItem';
import { InboxItemExtended } from 'src/types/inbox';

import { InboxItemCard, ResourcesInboxItemCard } from './InboxItemCard';

type InboxItemHotLinkContentProps = {
  isHotLink: boolean;
  setIsHotLink: React.Dispatch<React.SetStateAction<boolean>>;
};

export const InboxItemHotLinkContent: React.FC<InboxItemHotLinkContentProps> = ({
  isHotLink,
  setIsHotLink,
}) => {
  const inboxItemParamId = useInboxItemParamId();

  const { inboxItems } = useInboxItems();
  const { inboxItem, loading } = useInboxItemScrollableById(inboxItemParamId);

  const isFirstInboxItem = React.useMemo(() => {
    return inboxItems[0]?.id === inboxItem?.id;
  }, [inboxItems[0]?.id, inboxItem?.id]);

  const firstRenderEffectEvent = React.useEffectEvent(() => {
    setIsHotLink(!!inboxItemParamId);
  });
  React.useEffect(() => firstRenderEffectEvent(), []);

  const unsetHotLinkEffectEvent = React.useEffectEvent(() => {
    setIsHotLink(false);
  });
  React.useEffect(() => {
    if (!inboxItemParamId) {
      unsetHotLinkEffectEvent();
    }
  }, [inboxItemParamId]);

  if (!isHotLink || isFirstInboxItem || loading) {
    return null;
  }

  return <React.Fragment>{renderInboxItemCard(0, inboxItem)}</React.Fragment>;
};

const renderInboxItemCard = (
  _index: unknown,
  inboxItem: Nullable<InboxItemExtended<InboxListItemInfoFragment>>,
) => {
  if (!inboxItem) return null;
  if (inboxItem.type === InboxItemTypeWithResources.Resources) {
    return (
      <React.Fragment key={inboxItem.type}>
        <ResourcesInboxItemCard inboxItemId={inboxItem.id} />
      </React.Fragment>
    );
  }
  return (
    <React.Fragment key={inboxItem.id}>
      <InboxItemCard inboxItem={inboxItem} />
    </React.Fragment>
  );
};
